<template>
  <div id="contenedor-licitaciones-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar titulo="Licitaciones">
            <template v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirCalendario">
                    <v-icon> mdi-calendar-month </v-icon>
                  </v-btn>
                </template>
                <span> Calendario de Eventos </span>
              </v-tooltip>
              <v-tooltip left v-if="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'licitacionesEstadisticas' }">
                    <v-icon> mdi-poll </v-icon>
                  </v-btn>
                </template>
                <span> Estadisticas </span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{ name: 'licitacionesConfiguracionFirmas' }"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>
                <span> Configuración </span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :listaLicitaciones="getLicitacioes"
            :filtros="filtros"
            v-on:nuevaLicitacion="registrarNuevaLicitacion">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado
            :listadoLicitaciones="getListadoLicitaciones"
            :cargando="estaCargandoLicitaciones"
            :server-items-length="getPaginacion.total"
            :options.sync="tableOptions">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nueva-licitacion
        v-if="mostrarVentanaRegistrarNuevaLicitacion"
        v-on:cerrar="cerrarVentana">
      </registrar-nueva-licitacion>
    </v-dialog>
    <v-dialog
      v-if="estaLicitacion"
      v-model="mostrarVentanaEditarLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-licitacion
        :licitacionEditar="estaLicitacion"
        v-on:cerrar="cerrarVentana">
      </editar-licitacion>
    </v-dialog>
    <v-dialog
      v-if="estaLicitacion"
      v-model="mostrarVentanaEliminarLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-licitacion
        :licitacionEliminar="estaLicitacion"
        v-on:cerrar="cerrarVentana">
      </eliminar-licitacion>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="mostrarVentanaCalendario"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Calendario de Eventos de Licitaciones
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarVentana">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <calendario
            :eventosLicitaciones="getEventosLicitaciones"
            :cargando="estaCargandoCalendario">
          </calendario>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarVentana"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LICITACIONES_POR_PAGINA from '@/graphql/querys/administracion/licitaciones/licitacionesPorPagina.gql';
import LICITACIONES_CALENDARIO from '@/graphql/querys/administracion/licitaciones/licitacionesCalendario.gql';
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevaLicitacion from '@/components/administracion/licitaciones/Nueva.vue';
import EditarLicitacion from '@/components/administracion/licitaciones/Editar.vue';
import EliminarLicitacion from '@/components/administracion/licitaciones/Eliminar.vue';
import Calendario from '@/components/administracion/licitaciones/calendario/Calendario.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'LicitacionesDefault',
  components: {
    CustomButton,
    TituloToolBar,
    RegistrarNuevaLicitacion,
    EditarLicitacion,
    EliminarLicitacion,
    Calendario,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaLicitacion: false,
      mostrarVentanaCalendario: false,
      mostrarVentanaEditarLicitacion: false,
      mostrarVentanaEliminarLicitacion: false,
      estaLicitacion: null,
      tableOptions: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        normatividad: [],
        caracter: [],
        estatus: [],
      },
    };
  },
  apollo: {
    licitacionesPorPagina: {
      query: LICITACIONES_POR_PAGINA,
      variables() {
        return {
          filtros: this.construirFiltrosBackend(),
        };
      },
      skip() {
        return false;
      },
    },
    licitacionesCalendario: {
      query: LICITACIONES_CALENDARIO,
    },
  },
  activated() {
    this.$apollo.queries.licitacionesPorPagina.refetch();
  },
  watch: {
    'filtros.buscarTexto': function onBuscarTexto() {
      // Reset a página 1 cuando cambia búsqueda
      this.tableOptions.page = 1;
    },
    'filtros.tipos': function onTipos() {
      this.tableOptions.page = 1;
    },
    'filtros.normatividad': function onNormatividad() {
      this.tableOptions.page = 1;
    },
    'filtros.caracter': function onCaracter() {
      this.tableOptions.page = 1;
    },
    'filtros.estatus': function onEstatus() {
      this.tableOptions.page = 1;
    },
    'filtros.ejercicio': function onEjercicio() {
      this.tableOptions.page = 1;
    },
    tableOptions: {
      handler() {
        // Refetch cuando cambian page o itemsPerPage
        this.$apollo.queries.licitacionesPorPagina.refetch();
      },
      deep: true,
    },
  },
  mounted() {
    eventBus.$on('editar-licitacion', (licitacion) => {
      this.estaLicitacion = licitacion;
      this.mostrarVentanaEditarLicitacion = true;
    });
    eventBus.$on('eliminar-licitacion', (licitacion) => {
      this.estaLicitacion = licitacion;
      this.mostrarVentanaEliminarLicitacion = true;
    });
  },
  methods: {
    getOrdenamientoBackend() {
      const [sortBy] = this.tableOptions.sortBy || [];
      const [sortDesc] = this.tableOptions.sortDesc || [];
      const camposOrdenables = {
        numero: 'numero',
        fechaConvocatoria: 'fechaConvocatoria',
      };

      if (!sortBy || !camposOrdenables[sortBy]) {
        return {
          ordenarPor: 'fechaConvocatoria',
          orden: 'DESC',
        };
      }

      return {
        ordenarPor: camposOrdenables[sortBy],
        orden: sortDesc ? 'DESC' : 'ASC',
      };
    },
    construirFiltrosBackend() {
      const ordenamiento = this.getOrdenamientoBackend();
      const filtrosBackend = {
        ejercicio: this.filtros.ejercicio || undefined,
        buscar: this.filtros.buscarTexto || undefined,
        tipo: this.filtros.tipos.length === 1 ? this.filtros.tipos[0] : undefined,
        caracter: this.filtros.caracter.length === 1
          ? this.filtros.caracter[0] : undefined,
        normatividad: this.filtros.normatividad.length === 1
          ? this.filtros.normatividad[0] : undefined,
        estatus: this.filtros.estatus.length === 1 ? this.filtros.estatus[0] : undefined,
        pagina: this.tableOptions.page,
        limite: this.tableOptions.itemsPerPage,
        ordenarPor: ordenamiento.ordenarPor,
        orden: ordenamiento.orden,
      };

      // Si hay múltiples filtros de tipo, caracter, normatividad o estatus,
      // el filtrado se hace en cliente. Esto es una limitación del backend actual
      // que solo soporta un valor por campo.
      return filtrosBackend;
    },
    normalizarBusqueda(valor) {
      if (!valor) return '';
      return this.$normalizacionTexto(`${valor}`).toLowerCase();
    },
    abrirCalendario() {
      this.mostrarVentanaCalendario = true;
    },
    registrarNuevaLicitacion() {
      this.mostrarVentanaRegistrarNuevaLicitacion = true;
    },
    cerrarVentana() {
      this.mostrarVentanaCalendario = false;
      this.mostrarVentanaRegistrarNuevaLicitacion = false;
      this.mostrarVentanaEditarLicitacion = false;
      this.mostrarVentanaEliminarLicitacion = false;
      this.estaLicitacion = null;
    },
  },
  computed: {
    estaCargandoLicitaciones() {
      return this.$apollo.queries.licitacionesPorPagina.loading;
    },
    estaCargandoCalendario() {
      return this.$apollo.queries.licitacionesCalendario.loading;
    },
    getLicitacioes() {
      if (!this.licitacionesPorPagina) return [];
      return this.licitacionesPorPagina.datos || [];
    },
    getPaginacion() {
      if (!this.licitacionesPorPagina) {
        return {
          total: 0,
          pagina: 1,
          limite: 20,
          totalPaginas: 0,
        };
      }
      return this.licitacionesPorPagina.paginacion || {};
    },
    getListadoLicitaciones() {
      const licitaciones = this.getLicitacioes;
      if (!licitaciones.length) return [];

      return licitaciones
        // Agregar Ejercicio
        .map((licitacion) => ({
          ...licitacion,
          ejercicio: new Date(licitacion.fechaConvocatoria).getFullYear(),
        }))
        // Filtrar por múltiples Tipos (si es necesario)
        .filter(({ tipo }) => {
          if (this.filtros.tipos.length <= 1) return true;
          return this.filtros.tipos.includes(tipo);
        })
        // Filtrar por múltiple Normatividad
        .filter(({ normatividad }) => {
          if (this.filtros.normatividad.length <= 1) return true;
          return this.filtros.normatividad.includes(normatividad);
        })
        // Filtrar por múltiple Carácter
        .filter(({ caracter }) => {
          if (this.filtros.caracter.length <= 1) return true;
          return this.filtros.caracter.includes(caracter);
        })
        // Filtrar por múltiple Estatus
        .filter(({ estatus }) => {
          if (this.filtros.estatus.length <= 1) return true;
          return this.filtros.estatus.includes(estatus);
        });
    },
    getEventosLicitaciones() {
      if (!this.licitacionesCalendario) return [];
      return this.licitacionesCalendario;
    },
  },
};
</script>

<style lang="scss">

</style>
